import ACCESS from '../../ACCESS';

const options = [
  {
    type: "link",
    label: "Roles de Usuario",
    link: "/RolesUsuario",
    editlink: "/Rol/:id",
  },
  {
    type: "link",
    label: "Incidencias Manifiestos",
    link: "/IncidenciasManifiestos",
    access: [ACCESS.INCIDENCIAS_MANIFIESTOS.VER_INCIDENCIAS],
  },
  {
    type: "link",
    label: "Listas de Precios",
    link: "/ListasDePrecios",
    editlink: "/ListaPreciosEdit/:id",
    access: [ACCESS.LISTA_PRECIOS.VER_LISTA_PRECIOS],
  },
  {
    type: "children",
    label: "Digitalizacion de Documentos",
    parentLink: "/Digitalizar",
    children: [
      {
        type: "link",
        label: "Guias Entregadas",
        link: "/Digitalizar/GuiasEntregadas",
        editlink: "/Digitalizar/GuiaEntregada/:id?",
        access: [ACCESS.DIGITALIZAR.VER_DIGITALIZACIONES],
        acciones: [
          { value: "scan", label: "Escanear" },
        ],
      },
      {
        type: "link",
        label: "Reporte Guias Scaneadas",
        link: "/Digitalizar/Reporte",
        access: [ACCESS.DIGITALIZAR.REPORTE],
      },
    ],
  },
  {
    type: "children",
    label: "Recolecciones",
    parentLink: "/Preguias",
    children: [
      {
        type: "link",
        label: "Recolección",
        link: "/Preguias/Todas",
        editlink: "/Preguias/Preguia/:id?",
        access: [ACCESS.PREGUIA.VER_PREGUIAS_CREADAS_POR_EL_USUARIO, ACCESS.PREGUIA.VER_TODAS_PREGUIAS, ACCESS.PREGUIA.VER_PREGUIAS_SUCURSAL_DEL_USUARIO],
        acciones: [
          { value: "cancel", label: "Cancelar" },
          { value: "asignar", label: "Asignar Transportista" },
          { value: "confirmar", label: "Confirmar Recoleccion" },
          { value: "sucursal", label: "Confirmar entrada en sucursal" },
          { value: "historial", label: "Historial" },
          { value: "auth", label: "Autorizar" },
          { value: "print", label: "Imprimir" },
          { value: "detalles", label: "Cambiar Detalles de Carga" },
          { value: "carta_porte", label: "Carta Porte" },
        ],
      },
      {
        type: "link",
        label: "Reportes",
        link: "/Preguias/Reporte",
        access: [ACCESS.PREGUIA.REPORTE_ASIGNADAS_A_TRANSPORTISTA, ACCESS.PREGUIA.REPORTE_CONFIRMADAS_POR_TRANSPORTISTA,
        ACCESS.PREGUIA.REPORTE_DOCUMENTADAS, ACCESS.PREGUIA.REPORTE_EFECTUADAS_PENDIENTES_DE_DOCUMENTAR, ACCESS.PREGUIA.REPORTE_NO_CONFIRMADAS_POR_TRANSPORTISTA,
        ACCESS.PREGUIA.REPORTE_REALIZADAS_POR_TRANSPORTISTA, ACCESS.PREGUIA.REPORTE_TODAS_LAS_RECOLECCIONES]
      },
    ],
  },
  {
    type: "children",
    label: "Documentación",
    parentLink: "/Guias",
    children: [
      {
        acciones: [
          { value: "print", label: "Imprimir" },
          { value: "print_precios", label: "Imprimir Con Precios" },
          { value: "historial", label: "Ver Historial" },
          { value: "cancel", label: "Cancelar" },
          { value: "redocumentar", label: "Redocumentar" },
          { value: "etiqueta", label: "Imprimir Etiqueta" },
          { value: "full_edit", label: "Editar Sin Restricciones" },
          { value: "full_cancel", label: "Cancelar Sin Restricciones" },
          { value: "resend_email", label: "Reenviar email" },
          { value: "comment", label: "Comentarios Guia" },
        ],
        type: "link",
        label: "Guias",
        link: "/Guias/Todas",
        editlink: "/Guias/Guia/:id?",
        access: [ACCESS.GUIA.VER_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.GUIA.VER_GUIAS_SUCURSAL_DEL_USUARIO, ACCESS.GUIA.VER_TODAS_GUIAS, ACCESS.GUIA.VER_GUIAS_CLIENTE_DEL_USUARIO],
      },
      {
        type: "link",
        label: "Embarques",
        link: "/Guias/Embarques",
        editlink: "/Guias/Embarque/:id?",
        access: [ACCESS.EMBARQUE.VER_EMBARQUES_CREADOS_POR_EL_USUARIO, ACCESS.EMBARQUE.VER_EMBARQUES_SUCURSAL_DEL_USUARIO, ACCESS.EMBARQUE.VER_TODAS_EMBARQUES],
        acciones: [
          { value: "add_guia", label: "Agregar guias" },
          { value: "salida", label: "Salida Todos Embarques" },
          { value: "salida_self", label: "Salida Propios Embarques" },
          { value: "salida_sucursal", label: "Salida Embarques de Sucursal" },
          { value: "llegada", label: "Marcar Llegada Embarques" },
          { value: "llegada_self", label: "Marcar Llegada Propios Embarques" },
          { value: "llegada_sucursal", label: "Marcar Llegada de Embarques de Sucursal" },
          { value: "reporte", label: "Reporte PDF" },
          { value: "reporte_trafico", label: "Reporte Trafico" },
          { value: "reporte_ruta", label: "Reporte Embarque x Ruta" },
          { value: "reporte_etiqueta", label: "Reporte etiquetas y guias" },
          { value: "reporte_desembarque", label: "Reporte etiquetas embarque/desembarque" },
          { value: "full_edit", label: "Editar embarque sin importar status" },
          { value: "retraso", label: "Marcar Retraso" },
          { value: "carta_porte", label: "Carta Porte" },
          { value: "timbrar_carta_porte", label: "Timbrar Carta Porte" },
        ],
      },
      {
        type: "link",
        label: "Asignacion a Transportista",
        link: "/Guias/Entregas",
        access: [ACCESS.ASIGNACION_TRANSPORTISTA.VER_ASIGNACIONES_CREADAS_POR_EL_USUARIO,
        ACCESS.ASIGNACION_TRANSPORTISTA.VER_ASIGNACIONES_SUCURSAL_DEL_USUARIO, ACCESS.ASIGNACION_TRANSPORTISTA.VER_TODAS_ASIGNACIONES],
        acciones: [
          { value: "salida", label: "Marcar Salida" },
          { value: "ver", label: "Ver info" },
          {
            value: "full_edit",
            label: "Editar asignacion sin importar status",
          },
          { value: "timbrar_carta_porte", label: "Timbrar Carta Porte" },
        ],
      },
      {
        type: "link",
        label: "No entregado",
        link: "/Guias/EntregaDomicilio",
        access: [ACCESS.MARCAR_ENTREGAS.VER_GUIAS_PENDIENTES_DE_ENTREGA_CREADAS_POR_EL_USUARIO, ACCESS.MARCAR_ENTREGAS.VER_GUIAS_PENDIENTES_DE_ENTREGA_SUCURSAL_DEL_USUARIO,
        ACCESS.MARCAR_ENTREGAS.VER_TODAS_LAS_GUIAS_PENDIENTES_DE_ENTREGA
        ],
        acciones: [{ value: "entregada", label: "Marcar Entrega" }],
      },
      {
        type: "link",
        label: "Guias especiales",
        link: "/Guias/Especiales",
        access: [ACCESS.GUIA.ARCHIVO_CONCORD, ACCESS.GUIA.ARCHIVO_FLEXI, ACCESS.GUIA.ARCHIVO_ULINE, ACCESS.GUIA.ARCHIVO_PRODUCTOS_3M],
      },
      {
        type: "link",
        label: "Guias especiales Concord",
        link: "/Guias/Especiales/Concord",
        editlink: "/Guias/Especiales/Concord",
        hidden: true,
      },
      {
        type: "link",
        label: "Guias especiales Flexi",
        link: "/Guias/Especiales/Flexi",
        editlink: "/Guias/Especiales/Flexi",
        hidden: true,
      },
      {
        type: "link",
        label: "Guias especiales Uline",
        link: "/Guias/Especiales/Uline",
        editlink: "/Guias/Especiales/Uline",
        hidden: true,
      },
      {
        type: "link",
        label: "Guias especiales Urrea",
        link: "/Guias/Especiales/Urrea",
        editlink: "/Guias/Especiales/Urrea",
        hidden: true,
      },
      {
        type: "link",
        label: "Productos especiales",
        link: "/Guias/ProductosEspeciales",
        access: [ACCESS.GUIA.ARCHIVO_PRODUCTOS_3M, ACCESS.GUIA.ARCHIVO_PRODUCTOS_ULINE]
      },
      {
        type: "link",
        label: "Productos especiales ULINE",
        link: "/Guias/ProductosEspeciales/Uline",
        editlink: "/Guias/ProductosEspeciales/Uline",
        hidden: true,
      },
      {
        type: "link",
        label: "Productos especiales 3M",
        link: "/Guias/ProductosEspeciales/3M",
        editlink: "/Guias/ProductosEspeciales/3M",
        hidden: true,
      },
      {
        type: "link",
        label: "Guias Pendientes por CYC",
        link: "/Guias/PendientesCYC",
        access: [ACCESS.GUIAS_PENDIENTES_CYC.VER_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.GUIAS_PENDIENTES_CYC.VER_GUIAS_SUCURSAL_DEL_USUARIO,
        ACCESS.GUIAS_PENDIENTES_CYC.VER_TODAS_LAS_GUIAS],
        acciones: [{ value: "approve", label: "Aprobar" }],
      },
      {
        type: "link",
        label: "Envio Guias CYC",
        link: "/Guias/FacturasEnviadas",
        editlink: "/Guias/EnvioFacturas/:id?",
        access: [ACCESS.ENVIO_GUIAS_CYC.VER_FOLIOS_CREADOS_POR_EL_USUARIO, ACCESS.ENVIO_GUIAS_CYC.VER_FOLIOS_SUCURSAL_DEL_USUARIO,
        ACCESS.ENVIO_GUIAS_CYC.VER_TODOS_LOS_FOLIOS],
        acciones: [
          { value: "folio", label: "Ver Folio" },
          { value: "review", label: "Revisar" },
        ],
      },
      {
        type: "link",
        label: "Revisión de Evidencias",
        link: "/Guias/RevisionEvidencias",
        acciones: [{ value: "review", label: "Revisar" }],
        access: [ACCESS.REVISION_EVIDENCIAS.VER_EVIDENCIAS]
      },
      {
        type: "link",
        label: "Escaneo de Evidencias",
        link: "/Guias/EscaneoEvidencias",
        access: [ACCESS.ESCANEO_EVIDENCIAS.ESCANEAR_EVICENCIAS]
      },
      {
        type: "link",
        label: "Seguimiento de Guias",
        link: "/Guias/SeguimientoGuias",
        access: [ACCESS.SEGUIMIENTO_DE_GUIA.VER_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.SEGUIMIENTO_DE_GUIA.VER_GUIAS_SUCURSAL_DEL_USUARIO,
        ACCESS.SEGUIMIENTO_DE_GUIA.VER_TODAS_GUIAS]
      },
      {
        type: "link",
        label: "Impresion de Guias Multiple",
        link: "/Guias/ImpresionMultiple",
        access: [ACCESS.IMPRESION_MULTIPLE_GUIAS.IMPRIMIR_GUIAS]
      },
      {
        type: "link",
        label: "Seguimiento de Etiquetas de Guia",
        link: "/Guias/Etiquetas",
        editlink: "/Guias/Etiqueta/:id?",
        access: [ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_CREADAS_POR_EL_USUARIO,
        ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_SUCURSAL_DEL_USUARIO, ACCESS.SEGUIMIENTO_ETIQUETAS.VER_TODAS_ETIQUETAS]
      },
    ],
  },
  {
    type: "children",
    label: 'EAD',
    parentLink: "/EAD",
    children: [
      {
        type: "link",
        label: "Citas del Dia",
        link: "/EAD/CitasDia",
        access: [ACCESS.CITAS_EAD.VER_TODAS, ACCESS.CITAS_EAD.VER_TODAS_CLIENTE, ACCESS.CITAS_EAD.VER_TODAS_SUCURSAL, ACCESS.CITAS_EAD.VER_TODAS_USUARIO],
        acciones: [],
      },
      {
        type: "link",
        label: "Todas las Citas",
        link: "/EAD/Citas",
        access: [ACCESS.CITAS_EAD.VER_TODAS, ACCESS.CITAS_EAD.VER_TODAS_CLIENTE, ACCESS.CITAS_EAD.VER_TODAS_SUCURSAL, ACCESS.CITAS_EAD.VER_TODAS_USUARIO],
        acciones: [],
      },
    ]
  },
  {
    type: "children",
    label: "Ventas",
    parentLink: "/Ventas",
    children: [
      {
        type: "link",
        label: "Calcular KM",
        link: "/Ventas/Calcularkm",
        access: [ACCESS.VENTAS_CALCULAR_KM.CALCULAR_KM]
      },
      {
        type: "link",
        label: "Cotizaciones",
        editlink: "/Ventas/Cotizacion",
        link: "/Ventas/Cotizaciones",
        access: [ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_SUCURSAL_DEL_USUARIO, ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_SUCURSAL_DEL_USUARIO,
        ACCESS.VENTAS_COTIZACIONES.VER_TODAS_COTIZACIONES]
      },
      {
        type: "link",
        label: "Facturar Contado",
        link: "/Ventas/Facturas",
        access: [ACCESS.VENTAS_FACTURAS_CONTADO.VER_FACTURAS_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_FACTURAS_CONTADO.VER_FACTURAS_SUCURSAL_DEL_USUARIO,
        ACCESS.VENTAS_FACTURAS_CONTADO.VER_TODAS_FACTURAS
        ],
        acciones: [
          { value: "view", label: "Ver" },
          { value: "cancel", label: "Cancelar" },
          { value: "email", label: "Reenviar Facturas" },
          { value: "copy", label: "Copiar" },
        ],
      },
      {
        type: "link",
        label: "Facturar Credito",
        link: "/Ventas/FacturasCredito",
        access: [ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_SUCURSAL_DEL_USUARIO,
        ACCESS.VENTAS_FACTURAS_CREDITO.VER_TODAS_FACTURAS],
        acciones: [
          { value: "view", label: "Ver" },
          { value: "cancel", label: "Cancelar" },
          { value: "copy", label: "Copiar" },
        ],
      },
      {
        type: "link",
        label: "Refacturacion",
        access: [ACCESS.VENTAS_REFACTURACION.VER_TODAS_FACTURAS, ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_CREADAS_POR_EL_USUARIO,
        ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_SUCURSAL_DEL_USUARIO
        ],
        link: "/Ventas/Refacturaciones",
      },
      {
        type: "link",
        label: "Multiple Cancelacion",
        link: "/Ventas/CancelacionesFacturas",
        editlink: "/Ventas/CancelacionFactura",
        access: [ACCESS.VENTAS_MULTIPLE_CANCELACION.VER_CANCELACIONES]
      },
      {
        type: "link",
        label: "Facturar ULINE",
        link: "/Ventas/FacturaUline",
        access: [ACCESS.VENTAS_FACTURA_ULINE.CREAR_FACTURA_ULINE]
      },
      {
        type: "children",
        label: "Reportes",
        parentLink: "/Ventas/Reportes",
        children: [
          {
            type: "link",
            label: "Corte",
            link: "/Ventas/Reportes/Corte",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_CORTE]
          },
          {
            type: "link",
            label: "Ventas",
            link: "/Ventas/Reportes/Ventas",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_VENTAS]
          },
          {
            type: "link",
            label: "Anexo Corte por Redocumentacion",
            link: "/Ventas/Reportes/CorteRedocumentacion",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_ANEXO_CORTE_POR_REDOCUMENTACION]
          },
          {
            type: "link",
            label: "Guias Redocumentadas",
            link: "/Ventas/Reportes/GuiasRedocumentadas",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_GUIAS_REDOCUMENTADAS]
          },
          {
            type: "link",
            label: "Ventas por Concepto",
            link: "/Ventas/Reportes/VentasConcepto",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_VENTAS_POR_CONCEPTO]
          },
          {
            type: "link",
            label: "Contra recibos",
            link: "/Ventas/Reportes/Contra-recibos",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_CONTRA_RECIBOS]
          },
          {
            type: "link",
            label: "Completos",
            link: "/Ventas/Reportes/Completos",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_CONTRA_RECIBOS]
          },
          {
            type: "link",
            label: "Guias-Facts-Pagos",
            link: "/Ventas/Reportes/GuiasFactsPagos",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_GUIAS_PAGOS]
          },
          {
            type: "link",
            label: "Guias Recibidas en Facturación",
            link: "/Ventas/Reportes/RecibidasFacturacion",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_GUIAS_RECIBIDAS_EN_FACTURACION]
          },
          {
            type: "link",
            label: "Ventas por Cliente",
            link: "/Ventas/Reportes/VentasCliente",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_VENTAS_POR_CLIENTE]
          },
          {
            type: "link",
            label: "Ventas EAD",
            link: "/Ventas/Reportes/VentasEAD",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_VENTAS_EAD]
          },
          {
            type: "link",
            label: "Manifiestos",
            link: "/Ventas/Reportes/manifiestos",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_MANIFIESTOS]
          },
          {
            type: "link",
            label: "Contabilidad",
            link: "/Ventas/Reportes/contabilidad",
            access: [ACCESS.VENTAS_REPORTES.REPORTE_CONTABILIDAD]
          },
        ],
      },
    ],
  },
  {
    type: "children",
    label: "Cobranza",
    parentLink: "/Cobranza",
    children: [
      {
        type: "link",
        label: "Guias Recibidas",
        link: "/Cobranza/FacturasEnviadas",
        editlink: "/EnvioFacturas/:id?",
        acciones: [
          { value: "folio", label: "Ver Folio" },
          { value: "review", label: "Revisar" },
        ],
        access: [ACCESS.COBRANZA_GUIAS_RECIBIDAS.VER_TODAS_LOS_FOLIOS, ACCESS.COBRANZA_GUIAS_RECIBIDAS.VER_FOLIOS_SUCURSAL_DEL_USUARIO]
      },
      {
        type: "link",
        label: "Recibir Guias",
        link: "/Cobranza/RecibirGuia/:id",
        hidden: true,
        access: []
      },
      {
        type: "link",
        label: "Control de Depositos",
        link: "/Cobranza/Depositos",
        access: [ACCESS.COBRANZA_CONTROL_DEPOSITO.VER_TODOS_LOS_DEPOSITOS, ACCESS.COBRANZA_CONTROL_DEPOSITO.VER_DEPOSITOS_CREADOS_POR_EL_USUARIO]
      },
      {
        type: "link",
        label: "Descargar archivos",
        link: "/Cobranza/descargar-archivos",
        access: [ACCESS.COBRANZA_DESCARGA_DE_ARCHIVOS.DESCARGAR_FACTURA_CONTADO, ACCESS.COBRANZA_DESCARGA_DE_ARCHIVOS.DESCARGAR_FACTURA_CREDITO,
        ACCESS.COBRANZA_DESCARGA_DE_ARCHIVOS.DESCARGAR_NOTA_CREDITO]
      },
      {
        type: "link",
        label: "Envio de facturas",
        link: "/Cobranza/envio-facturas",
        editlink: "/Cobranza/envio-factura/:id?",
        acciones: [
          { value: "recibir", label: "Marcar como recibido" },
        ],
        access: [ACCESS.COBRANZA_ENVIO_FACTURAS.VER_TODOS_LOS_FOLIOS, ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_SUCURSAL_USUARIO,
        ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_CREADOS_POR_USUARIO
        ]
      },
      {
        type: "link",
        label: "Editar depositos",
        link: "/Cobranza/DepositosDetalle/:id",
        editlink: "/Cobranza/Deposito/:id",
        hidden: true,
        access: [],
        acciones: [
          { value: "hacer_deposito", label: "Hacer depositos" },
          { value: "identificar_deposito", label: "Identificar depositos" },
        ],
      },
      {
        type: "children",
        parentLink: "/Cobranza/ApliacionPago/Busqueda",
        label: "Aplicacion Pagos",
        children: [
          {
            type: "link",
            label: "Contado",
            link: "/Cobranza/ApliacionPago/Busqueda/Contado",
            editlink: "/Cobranza/ApliacionPago/Depositos",
            access: [ACCESS.COBRANZA_APLICACION_PAGOS.VER_CONTADO]
          },
          {
            type: "link",
            label: "Crédito",
            link: "/Cobranza/ApliacionPago/Busqueda/Credito",
            editlink: "/Cobranza/ApliacionPago/Depositos",
            access: [ACCESS.COBRANZA_APLICACION_PAGOS.VER_CREDITO]
          },
        ],
      },
      {
        type: "link",
        label: "Poliza Contable",
        link: "/Cobranza/poliza-contable",
        access: [ACCESS.COBRANZA_POLIZA_CONTABLE.DESCARGAR]
      },
      {
        type: "link",
        label: "Notas de crédito",
        link: "/Cobranza/notas-credito",
        editlink: "/Cobranza/nota-credito/:id?",
        acciones: [{ value: "files", label: "Descargar Archivos" }],
        access: [ACCESS.COBRANZA_NOTA_CREDITO.VER_TODAS_NOTAS_CREDITO, ACCESS.COBRANZA_NOTA_CREDITO.VER_NOTAS_CREADAS_POR_EL_USUARIO]
      },
      {
        type: "link",
        label: "Contra recibos",
        link: "/Cobranza/contra-recibos",
        acciones: [{ value: "add", label: "Agregar" }],
        access: [ACCESS.COBRANZA_CONTRA_RECIBO.VER_TODOS_LOS_CONTRARECIBOS]
      },
      {
        type: "link",
        label: "Reportes",
        link: "/Cobranza/reportes",
        access: [ACCESS.COBRANZA_REPORTES.REPORTE_ESTADO_DE_CUENTA, ACCESS.COBRANZA_REPORTES.REPORTE_MOVIMIENTOS_CLIENTE,
        ACCESS.COBRANZA_REPORTES.REPORTE_COBRANZA_DETALLADA, ACCESS.COBRANZA_REPORTES.REPORTE_COBRANZA_GLOBAL]
      },
      {
        type: "link",
        label: "Reporte de Pagos Credito",
        link: "/Cobranza/reporte-pagos",
        access: [ACCESS.COBRANZA_REPORTES.REPORTE_DE_PAGOS_CREDITO]
      },
      {
        type: "link",
        label: "Reporte de Pagos Contado",
        link: "/Cobranza/reporte-pagos-contado",
        access: [ACCESS.COBRANZA_REPORTES.REPORTE_DE_PAGOS_CONTADO]
      },
      {
        type: "link",
        label: "Reporte de Pagos Pendientes",
        link: "/Cobranza/reporte-pagos-pendientes",
        access: [ACCESS.COBRANZA_REPORTES.REPORTE_DE_PAGOS_PENDIENTES]
      },
      {
        type: "link",
        label: "Reporte Diferencia en Pagos",
        link: "/Cobranza/reporte-diferencia-pagos",
        access: [ACCESS.COBRANZA_REPORTES.REPORTE_DIFERENCIA_DE_PAGOS]
      },
      {
        type: "link",
        label: "Report. Relacion Fact.",
        link: "/Cobranza/reporte-relacion-fact",
        access: [ACCESS.COBRANZA_REPORTES.REPORTE_RELACION_FACTURAS]
      },
      {
        type: "link",
        label: "Report. Para Rutas",
        link: "/Cobranza/reporte-rutas",
        access: [ACCESS.COBRANZA_REPORTES.REPORTE_PARA_RUTAS]
      },
      {
        type: "children",
        label: "Pago a transportista",
        parentLink: "/Cobranza/pagos",
        children: [
          {
            type: "link",
            label: "Recolección",
            link: "/Cobranza/pagos/pago-transportista",
            access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.PAGO_RECOLECCION]
          },
          {
            type: "link",
            label: "Entrega",
            link: "/Cobranza/pagos/pago-entrega",
            access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.PAGO_ENTREGA]
          },
          {
            type: "link",
            label: "Reporte Pago Entrega",
            link: "/Cobranza/pagos/pago-transportista-entrega",
            access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.PAGO_ENTREGA]
          },
          {
            type: "link",
            label: "Detalle de Pagos",
            link: "/Cobranza/pagos/detalle-pago-transportista",
            access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.VER_DETALLE_PAGO_TRANSPORTISTA]
          },
        ],
      },
      {
        type: "link",
        label: "Guias Pendientes",
        link: "/Cobranza/GuiasPendientes",
        access: [ACCESS.COBRANZA_GUIAS_PENDIENTES.DESCARGAR_REPORTE]
      },
      {
        type: "link",
        label: "Consecutivo de Facturas",
        link: "/Cobranza/FacturasConsecutivo",
        access: [ACCESS.COBRANZA_CONSECUTIVO_DE_FACTURAS.DESCARGAR_REPORTE]
      },
      {
        type: "link",
        label: "Consulta Saldo Facturista",
        link: "/Cobranza/ConsultaSaldoFacturista",
        access: [ACCESS.COBRANZA_SALDO_FACTURISTA]
      },
      {
        type: "link",
        label: "Facturas Por Cliente",
        link: "/Cobranza/FacturasClientes",
        editlink: "/Cobranza/FacturaCliente/:id?",
        acciones: [{ value: "contrarecibo", label: "Contrarecibo" }],
        access: [ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.VER_TODOS_LOS_FOLIOS, ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.VER_FOLIOS_CREADOS_POR_USUARIO],
      },
      {
        type: "link",
        label: "Facturas SAT Faltantes",
        link: "/Cobranza/FacturasSatFaltantes",
        access: [ACCESS.COBRANZA_REPORTES.REPORTE_FACTURAS_SAT_FALTANTES]
      },
    ],
  },
  {
    type: "link",
    label: "Archivos de clientes",
    link: "/Manifiestos/:id?",
    access: [ACCESS.ARCHIVOS_DE_CLIENTE.SUBIR_ARCHIVO]
  },
  {
    type: "children",
    label: "Catalogos",
    parentLink: "/Catalogo",
    children: [
      {
        type: "link",
        label: "Actualizacion Precio Combustible",
        link: "/Catalogo/PreciosCombustibles",
        editlink: "/Catalogo/PrecioCombustible/:id",
        access: [ACCESS.CATALOGOS_PRECIO_COMBUSTIBLE.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Bancos",
        link: "/Catalogo/Bancos",
        editlink: "/Catalogo/Banco/:id",
        access: [ACCESS.CATALOGO_BANCOS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Camiones",
        link: "/Catalogo/Camiones",
        editlink: "/Catalogo/Camion/:id?",
        access: [ACCESS.CATALOGO_CAMIONES.VER_CATALOGO]
      },
      {
        type: "link",
        label: "CPAC",
        link: "/Catalogo/CpacValores",
        editlink: "/Catalogo/CpacValor/:id",
        access: [ACCESS.CATALOGO_CPAC.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Cargos/Creditos",
        link: "/Catalogo/Cargos",
        editlink: "/Catalogo/Cargo/:id",
        access: [ACCESS.CATALOGO_CARGOS_CREDITOS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Choferes",
        link: "/Catalogo/Choferes",
        editlink: "/Catalogo/Chofer/:id?",
        access: [ACCESS.CATALOGO_CHOFERES.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Circuitos",
        link: "/Catalogo/Circuitos",
        editlink: "/Catalogo/Circuito/:id?",
        access: [ACCESS.CATALOGO_CIRCUITOS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Clientes",
        link: "/Catalogo/Clientes",
        editlink: "/Catalogo/Cliente/:id/:tab?/:tabId?",
        // acciones: [{ value: "contado", label: "SOLO CONTADO" }],
        access: [ACCESS.CATALOGO_CLIENTES.VER_CATALOGO, ACCESS.CATALOGO_CLIENTES.VER_SOLO_CONTADO, ACCESS.CATALOGO_CLIENTES.VER_SOLO_CREDITO]
      },
      {
        type: "children",
        label: "Clientes",
        parentLink: "/Catalogo/Clientes",
        access: [ACCESS.CATALOGO_CLIENTES.VER_CATALOGO, ACCESS.CATALOGO_CLIENTES.VER_SOLO_CONTADO, ACCESS.CATALOGO_CLIENTES.VER_SOLO_CREDITO],
        hidden: true,
        children: [
          {
            type: "link",
            label: "Datos Generales",
            link: "/Catalogo/Cliente/:id/Generales",
            editlink: "/Catalogo/Cliente/:id/Generales",
            access: [ACCESS.CATALOGO_CLIENTES.VER_CATALOGO, ACCESS.CATALOGO_CLIENTES.VER_SOLO_CONTADO, ACCESS.CATALOGO_CLIENTES.VER_SOLO_CREDITO],
          },
          {
            type: "link",
            label: "Grupo",
            link: "/Catalogo/Cliente/:id/Grupos/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Grupos/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_GRUPO.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Remitente",
            link: "/Catalogo/Cliente/:id/Remitentes/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Remitentes/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_REMITENTE.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Destinatario",
            link: "/Catalogo/Cliente/:id/Destinatarios/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Destinatarios/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_DESTINATARIO.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Ventas",
            link: "/Catalogo/Cliente/:id/Ventas/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Ventas/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_VENTA.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Administrativos",
            link: "/Catalogo/Cliente/:id/Administrativos/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Administrativos/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_ADMINISTRATIVO.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Estadisticos",
            link: "/Catalogo/Cliente/:id/Estadisticos/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Estadisticos/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_ESTADISTICO.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Rep Legal",
            link: "/Catalogo/Cliente/:id/Representante/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Representante/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_REP_LEGAL.VER_CATALOGO],
          },
          {
            type: "link",
            label: "CFDI",
            link: "/Catalogo/Cliente/:id/Cfdi/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Cfdi/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_CFDI.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Convenio",
            link: "/Catalogo/Cliente/:id/Convenios/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Convenios/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_CONVENIO.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Precio",
            link: "/Catalogo/Cliente/:id/Precios/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Precios/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_PRECIO.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Pagos",
            link: "/Catalogo/Cliente/:id/Pagos/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Pagos/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_PAGO.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Folio",
            link: "/Catalogo/Cliente/:id/FoliosUso/:tabId?",
            editlink: "/Catalogo/Cliente/:id/FoliosUso/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_FOLIO.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Pago transportista",
            link: "/Catalogo/Cliente/:id/PagoTransportista/:tabId?",
            editlink: "/Catalogo/Cliente/:id/PagoTransportista/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_PAGO_TRANSPORTISTA.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Factoraje",
            link: "/Catalogo/Cliente/:id/Factoraje/:tabId?",
            editlink: "/Catalogo/Cliente/:id/Factoraje/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_FACTORAJE.VER_CATALOGO],
          },
          {
            type: "link",
            label: "Api",
            link: "/Catalogo/Cliente/:id/API/:tabId?",
            editlink: "/Catalogo/Cliente/:id/API/:tabId?",
            access: [ACCESS.CATALOGO_CLIENTES_API.VER_CATALOGO],
          },
        ],
      },
      {
        type: "link",
        label: "Colonias",
        link: "/Catalogo/Colonias",
        editlink: "/Catalogo/Colonia/:id?",
        access: [ACCESS.CATALOGO_COLONIAS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Códigos Postales",
        link: "/Catalogo/CodigosPostales",
        editlink: "/Catalogo/CodigoPostal/:id?",
        access: [ACCESS.CATALOGO_COLONIAS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Conceptos de Redocumentacion",
        link: "/Catalogo/Redocumentaciones",
        editlink: "/Catalogo/Redocumentacion/:id",
        access: [ACCESS.CATALOGO_CONCEPTOS_DE_REDOCUMENTACION.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Condiciones de Pago",
        link: "/Catalogo/CondicionesPagos",
        editlink: "/Catalogo/CondicionPago/:id",
        access: [ACCESS.CATALOGO_CONDICIONES_DE_PAGO.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Cuentas Bancarias",
        link: "/Catalogo/CuentasBancarias",
        editlink: "/Catalogo/CuentaBancaria/:id",
        access: [ACCESS.CATALOGO_CUENTAS_BANCARIAS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Ejecutivos",
        link: "/Catalogo/Ejecutivos",
        editlink: "/Catalogo/Ejecutivo/:id",
        access: [ACCESS.CATALOGO_EJECUTIVOS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Embalajes",
        link: "/Catalogo/Embalajes",
        editlink: "/Catalogo/Embalaje/:id",
        access: [ACCESS.CATALOGO_EMBALAJES.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Fallas de Desembarque",
        link: "/Catalogo/FallasDesembarques",
        editlink: "/Catalogo/FallaDesembarque/:id",
        access: [ACCESS.CATALOGO_FALLAS_DE_DESEMBARQUE.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Formas de Pago",
        link: "/Catalogo/FormasPago",
        editlink: "/Catalogo/FormaPago/:id",
        access: [ACCESS.CATALOGO_FORMAS_DE_PAGO.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Giros",
        link: "/Catalogo/Giros",
        editlink: "/Catalogo/Giro/:id",
        access: [ACCESS.CATALOGO_GIROS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Grupos de Embalaje",
        link: "/Catalogo/GruposEmbalajes",
        editlink: "/Catalogo/GrupoEmbalaje/:id",
        access: [ACCESS.CATALOGO_GRUPOS_DE_EMBALAJE.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Impuestos",
        link: "/Catalogo/Impuestos",
        editlink: "/Catalogo/Impuesto/:id",
        access: [ACCESS.CATALOGO_IMPUESTOS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Lineas de Transporte",
        link: "/Catalogo/LineasTransportes",
        editlink: "/Catalogo/LineaTransporte/:id",
        access: [ACCESS.CATALOGO_LINEAS_DE_TRANSPORTE.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Lugares",
        link: "/Catalogo/Lugares",
        editlink: "/Catalogo/Lugar/:id",
        access: [ACCESS.CATALOGO_LUGARES.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Metodos de Pago",
        link: "/Catalogo/MetodosPago",
        editlink: "/Catalogo/MetodoPago/:id",
        access: [ACCESS.CATALOGO_METODOS_DE_PAGO.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Motivo Depuracion",
        link: "/Catalogo/MotivosDepuracion",
        editlink: "/Catalogo/MotivoDepuracion/:id",
        access: [ACCESS.CATALOGO_MOTIVOS_ATRASO_EMBARQUE.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Motivos Atraso Embarque",
        link: "/Catalogo/MotivosAtrasoEmbarque",
        editlink: "/Catalogo/MotivoAtrasoEmbarque/:id",
        access: [ACCESS.CATALOGO_MOTIVOS_ATRASO_EMBARQUE.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Motivos de Rechazo",
        link: "/Catalogo/MotivosRechazo",
        editlink: "/Catalogo/MotivoRechazo/:id",
        access: [ACCESS.CATALOGO_MOTIVOS_DE_RECHAZO.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Motivos de entrega tarde",
        link: "/Catalogo/MotivosTarde",
        editlink: "/Catalogo/MotivoTarde/:id",
        access: [ACCESS.CATALOGO_MOTIVOS_DE_ENTREGA_TARDE.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Orígenes",
        link: "/Catalogo/OrigenesDestinos",
        editlink: "/Catalogo/OrigenDestino/:id",
        access: [ACCESS.CATALOGO_ORIGENES.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Regimenes Fiscales CFDI",
        link: "/Catalogo/CfdiFiscalRegimenes",
        editlink: "/Catalogo/CfdiFiscalRegimen/:id",
        access: [ACCESS.CATALOGO_REGIMENES_FISCALES_CFDI.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Rutas",
        link: "/Catalogo/Rutas",
        editlink: "/Catalogo/Ruta/:id",
        access: [ACCESS.CATALOGO_RUTAS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Rutas transportista",
        link: "/Catalogo/TransportistasRutas",
        editlink: "/Catalogo/TransportistaRuta/:id",
        access: [ACCESS.CATALOGO_RUTAS_TRANSPORTISTA.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Remolques",
        link: "/Catalogo/Remolques",
        editlink: "/Catalogo/Remolque/:id",
        access: [ACCESS.CATALOGO_REMOLQUES.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Sucursales",
        link: "/Catalogo/Sucursales",
        editlink: "/Catalogo/Sucursal/:id",
        access: [ACCESS.CATALOGO_SUCURSALES.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Tipos de Cargos/Creditos",
        link: "/Catalogo/TiposCargos",
        editlink: "/Catalogo/TipoCargo/:id",
        access: [ACCESS.CATALOGO_TIPOS_DE_CARGOS_CREDITOS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Tipos de Lista de Precios",
        link: "/Catalogo/ListasPreciosTipos",
        editlink: "/Catalogo/ListaPrecioTipo/:id",
        access: [ACCESS.CATALOGO_TIPOS_DE_LISTA_DE_PRECIOS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Tipos Seguimiento de Guias",
        link: "/Catalogo/TiposSeguimiento",
        editlink: "/Catalogo/TipoSeguimiento/:id?",
        access: [ACCESS.CATALOGO_TIPOS_SEGUIMIENTO_DE_GUIAS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Transportistas",
        link: "/Catalogo/Transportistas",
        editlink: "/Catalogo/Transportista/:id",
        access: [ACCESS.CATALOGO_TRANSPORTISTAS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Unidades de Medida CFDI",
        link: "/Catalogo/CfdiMedidaUnidades",
        editlink: "/Catalogo/CfdiMedidaUnidad/:id",
        access: [ACCESS.CATALOGO_UNIDADES_DE_MEDIDA_CFDI.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Unidades de Transporte",
        link: "/Catalogo/UnidadesTransporte",
        editlink: "/Catalogo/UnidadTransporte/:id",
        access: [ACCESS.CATALOGO_UNIDADES_DE_TRANSPORTE.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Usos CFDI",
        link: "/Catalogo/CfdiUsos",
        editlink: "/Catalogo/CfdiUso/:id",
        access: [ACCESS.CATALOGO_USOS_CFDI.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Zonas",
        link: "/Catalogo/Zonas",
        editlink: "/Catalogo/Zona/:id",
        access: [ACCESS.CATALOGO_ZONAS.VER_CATALOGO]
      },
      {
        type: "link",
        label: "Zonas KM",
        link: "/Catalogo/ZonasKm",
        editlink: "/Catalogo/ZonaKm/:id",
        access: [ACCESS.CATALOGO_ZONAS_KM.VER_CATALOGO]
      },
    ],
  },
];

export default options;
